import { useEffect, useState } from "react";
import "./Requests.css";
import RequestsField from "../../RequestsField";
import LoadingRequests from "./LoadingRequests/LoadingRequests";
import { useInterval } from "../../useInterval";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearAddresses } from "../../../slices/managerSlice";
import { enHSInstance } from "../../../App";
import SegmentButton from "../../SegmentButton/SegmentButton";
import ClientsField from "../../ClientsField/ClientsField";
import ConnectionError from "../../ConnectionError/ConnectionError";

function Requests() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [requests, setRequests] = useState(null);
  const [requestsError, setRequestsError] = useState(null);
  const [choosePage, setChoosePage] = useState(0);
  const [clientList, setClientList] = useState(null);
  const [clientsError, setClientsError] = useState(null);

  useEffect(() => {
    localStorage.setItem("theme", "light");
    sessionStorage.clear();
    dispatch(clearAddresses());
  }, [dispatch]);

  async function GetRequestsData() {
    try {
      const response = await enHSInstance.post(
        `https://api-erkon.tech/mobile/hs/ObmenMP/SpisokZayavokPWA`,
        {},
        {
          headers: {
            token: localStorage.getItem("tokenMANAGER"),
          },
        },
      );

      if (response.status === 200) {
        const data = await response.data;

        if (Array.isArray(data)) {
          setRequests(data);
          setRequestsError(null);
        } else {
          setRequestsError('invalid');
        }
      } else {
        setRequestsError(response.status);
      }
    } catch (e) {
      if (e.response?.status === 401) {
        localStorage.removeItem("tokenMANAGER");
        window.location.replace('/login');
      } else {
        setRequestsError(e.response?.status || 'network');
      }
    }
  }

  async function GetClientsData() {
    try {
      const response = await enHSInstance.post(
        `https://api-erkon.tech/mobile/hs/ObmenMP/clientList`,
        {},
        {
          headers: {
            token: localStorage.getItem("tokenMANAGER"),
          },
        },
      );
      if (response.status === 200) {
        const data = await response.data;

        if (Array.isArray(data)) {
          setClientList(data);
          setClientsError(null);
        } else {
          setClientsError('invalid');
        }
      } else {
        setClientsError(response.status);
      }
    } catch (e) {
      if (e.response?.status === 401) {
        localStorage.removeItem("tokenMANAGER");
        window.location.replace('/login');
      } else {
        setClientsError(e.response?.status || 'network');
      }
    }
  }

  useEffect(() => {
    GetRequestsData();
    GetClientsData();
  }, []);

  useInterval(() => {
    GetRequestsData();
  }, 15000);

  useInterval(() => {
    GetClientsData();
  }, 18000);

  const renderComponent = (
    <>
      {choosePage === 0 ? requests === null ? (
        requestsError ? <ConnectionError status={requestsError} onRetry={GetRequestsData} /> : <LoadingRequests />
      ) : (
        <div className="requestsWrapper">
          <RequestsField
            filteredRequests={requests}
            status={"Плановая"}
            substatus={"На проверке"}
          />
        </div>
      ) : clientList === null ? (
        clientsError ? <ConnectionError status={clientsError} onRetry={GetClientsData} /> : <LoadingRequests />
      ) : (
        <div className="clientsWrapper">
          <ClientsField data={clientList} />
        </div>
      )}
    </>
  );

  return (
    <div className="requestsLayout">
      <SegmentButton
        segments={["Заявки", "Клиенты"]}
        onSegmentChange={setChoosePage}
        chosen={choosePage}
        badgeIndex={clientList?.length > 0 ? 1 : undefined}
      />
      <div className="requestsContent">
        {choosePage === 0 && requests !== null && requestsError && (
          <ConnectionError status={requestsError} onRetry={GetRequestsData} />
        )}
        {choosePage === 1 && clientList !== null && clientsError && (
          <ConnectionError status={clientsError} onRetry={GetClientsData} />
        )}
        {renderComponent}
      </div>
      <div className="footerSendButtonAddress">
        <div className="sendButtonPlaceholder">
          <button
            onClick={() => navigate("addresses")}
            className="sendButtonActive"
          >
            Адреса
          </button>
        </div>
      </div>
    </div>
  );
}

export default Requests;
